export default __webpack_public_path__ + "static/media/898b822c0937fbe8375953895ccdf4361600874093631.1fbefda2.webp";